import { createReducer, on } from '@ngrx/store';
import { setFundChartSplitType } from './split-type.actions';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
import { SPLIT_TYPE_DEFAULT } from 'ChartApp/ts/features/fundamental-chart/constants';
export const splitType = createReducer(SPLIT_TYPE_DEFAULT, on(setChartData, (state, { chartData }) => chartData.params.splitType), on(setFundChartSplitType, (state, { splitType: newSplitType }) => newSplitType));
